import {Localizer} from "../../../infrastructure/localization/localizer";

export enum KompetenceDatoKategoriEnum {
    UnderEnUge = 1,
    OverEnUge = 2,
    OverEnMaaned = 3,
    OverTreMaaneder = 4,
    IngenAktivitet = 5,
}

export function GetKompetenceTimeString(status: KompetenceDatoKategoriEnum): string {
    switch (status) {
        case KompetenceDatoKategoriEnum.IngenAktivitet:
            return Localizer.dashboard_ingenAktivitet();
        case KompetenceDatoKategoriEnum.UnderEnUge:
            return Localizer.dashboard_underEnUge();
        case KompetenceDatoKategoriEnum.OverEnUge:
            return Localizer.dashboard_overEnUge();
        case KompetenceDatoKategoriEnum.OverEnMaaned:
            return Localizer.dashboard_overEnMaaned();
        case KompetenceDatoKategoriEnum.OverTreMaaneder:
            return Localizer.dashboard_overTreMaaneder();
        default:
            return "";
    }
}

